import { render, staticRenderFns } from "./setURL.vue?vue&type=template&id=65fd6723&scoped=true&"
import script from "./setURL.vue?vue&type=script&lang=js&"
export * from "./setURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd6723",
  null
  
)

export default component.exports